// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h3 {
  margin-top: 25px;
  margin-bottom: 15px;
}

input[type=text] {
  border: 0;
  padding: inherit;
  width: 100%;
}

.accntInfo table tr td label {
  font-size: 14px;
  margin-bottom: auto;
}

.accntInfo table tr td:nth-child(2) {
  padding-left: 5px;
}

.accntInfo table tr td {
  padding-top: 12px;
}

#subAccountDisplay {
  max-height: 75px;
}

tr.actionModify {
  margin-bottom: 8px;
}

tr.actionModify td {
  border-bottom: 1px solid #EDF2F5;
  padding-bottom: 2px;
}

tr.actionModify td:nth-child(2) {
  padding-right: 15px;
}

tr.actionModify td:last-child {
  width: auto !important;
  vertical-align: middle;
}

.hide {
  display: none;
}

select {
  background-color: white;
  width: 100%;
  border: 0;
  border-radius: 0;
  padding: 0;
}

select option {
  padding-left: 0;
}

tr.actionModify td:first-child {
  width: 150px;
}

tr.actionModify td:last-child div.editable {
  display: none;
}

tr.actionModify:hover td:last-child div.editable {
  display: block;
  cursor: pointer;
}

tr.actionModify:hover td:last-child div.editable div.editableIcon {
  height: 16px;
  width: 16px;
  background: url(/assets/administration/pencil-tool.png) no-repeat;
}

tr.actionModify:hover td:last-child div.editable div.editableIcon:hover {
  background: url(/assets/administration/pencil-tool_on.png) no-repeat;
}

tr.modifyButtons td {
  padding-top: 0 !important;
}

tr.modifyButtons td div.edit {
  text-align: right;
}

tr.modifyButtons td div.edit div.saveText,
tr.modifyButtons td div.edit div.cancelText {
  cursor: pointer;
}

tr.modifyButtons td div.edit div.saveText {
  color: #007566;
}

tr.actionModify td:last-child div.edit div.cancelText {
  cursor: pointer;
}

tr.modifyButtons td.modifyEnabled:nth-child(2), tr.actionModify td.modifyEnabled {
  border-bottom: 2px solid #007566;
}

tr.actionModify td.splitLineTile:after {
  content: ""; /* This is necessary for the pseudo element to work. */
  display: block; /* This will put the pseudo element on its own line. */
  margin: 0 0 -3px; /* This will center the border. */
  width: 15%; /* Change this to whatever width you want. */
  padding-top: 0; /* This creates some space between the element and the border. */
  border-bottom: 2px solid #007566;
  /* This creates the border. Replace black with whatever color you want. */
}

table:not(.permissionsTable) tr td:nth-child(1) {
  font-family: "MontserratRegular", sans-serif;
}

.permissionsTable {
  width: 100%;
}

.permissionsTable td:first-child {
  width: 16% !important;
}

.permissionsTable td:nth-child(even),
.permissionsTable td.iacTd {
  width: 5% !important;
}

.permissionsTable td:nth-child(3) {
  width: 18% !important;
}

.permissionsTable td:nth-child(5),
.permissionsTable td:nth-child(7) {
  width: 12% !important;
}

div.col-md-6, .pdl0 {
  padding-left: 0;
}

#pageHead {
  width: 100%;
  background-color: #F4F4F4;
  margin: 0;
  height: 50px;
}

.modalButton {
  background-color: white;
  color: #111111;
}

.modalButton:hover {
  background-color: #EDF2F5;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp {
  border: 0;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .datePicker {
  padding: 0;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selector:focus {
  border: 1px solid #BABABA !important;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selector {
  border: 1px solid #BABABA !important;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selectorarrow:before {
  border: none !important;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selectorarrow:focus:before {
  border: none !important;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .daycell:hover .prevmonth,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .daycell:hover .nextmonth {
  color: #111111;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .currmonth .sunday,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .sundayDim {
  color: #999 !important;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selectedday {
  border: 1px solid #686868;
  background-color: #BABABA;
  color: black;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selectedday div {
  background-color: #BABABA !important;
  color: black;
  border: none !important;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .headertodaybtn {
  border-radius: 0 !important;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .caltable,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .daycell,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .weekdaytitle {
  color: #111111;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .mydpicon:hover,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .mydpicon:focus,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .btnpicker:hover,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .btnpicker:focus {
  background-color: white !important;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .btnclear:hover,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .btnclear:focus,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .mydpicon:hover,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .daycell:hover,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .headertodaybtn:hover {
  background-color: #CCC;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .headerbtn:hover,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .headerlabelbtn:hover {
  color: #CCC;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .icon-mydpleft:hover,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .icon-mydpright:hover {
  color: #111111;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .icon-mydpleft:focus,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .icon-mydpright:focus {
  color: #999;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selection {
  font-size: 9pt !important;
  height: auto !important;
  padding: 0 !important;
  margin-top: 3px !important;
  font-family: "MontserratLight", sans-serif !important;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .selbtngroup {
  height: auto !important;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .selbtngroup .btnclear {
  height: auto;
  padding: 0;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .selbtngroup .btnpicker {
  height: auto;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/administration/components/administration-user/administration-user.component.scss"],"names":[],"mappings":"AACA;EACI,gBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,SAAA;EACA,gBAAA;EACA,WAAA;AAAJ;;AAGA;EACI,eAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,iBAAA;AAAJ;;AAGA;EACI,iBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI,gCAAA;EACA,mBAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,sBAAA;EACA,sBAAA;AADJ;;AAIA;EACI,aAAA;AADJ;;AAIA;EACI,uBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;AADJ;;AAGA;EACI,eAAA;AAAJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,aAAA;AADJ;;AAIA;EACI,cAAA;EACA,eAAA;AADJ;;AAIA;EACI,YAAA;EACA,WAAA;EACA,iEAAA;AADJ;;AAIA;EACI,oEAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACI,iBAAA;AADJ;;AAIA;;EAEI,eAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,gCAAA;AADJ;;AAIA;EACI,WAAA,EAAA,sDAAA;EACA,cAAA,EAAA,sDAAA;EACA,gBAAA,EAAA,iCAAA;EACA,UAAA,EAAA,4CAAA;EACA,cAAA,EAAA,gEAAA;EACA,gCAAA;EACA,yEAAA;AADJ;;AAIA;EACI,4CAAA;AADJ;;AAIA;EACI,WAAA;AADJ;;AAIA;EACI,qBAAA;AADJ;;AAIA;;EAEI,oBAAA;AADJ;;AAIA;EACI,qBAAA;AADJ;;AAIA;;EAEI,qBAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,WAAA;EACA,yBAAA;EACA,SAAA;EACA,YAAA;AADJ;;AAIA;EACI,uBAAA;EACA,cAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACI,SAAA;AADJ;;AAIA;EACI,UAAA;AADJ;;AAIA;EACI,oCAAA;AADJ;;AAIA;EACI,oCAAA;AADJ;;AAIA;EACI,uBAAA;AADJ;;AAIA;EACI,uBAAA;AADJ;;AAIA;;EAEI,cAAA;AADJ;;AAIA;;EAEI,sBAAA;AADJ;;AAIA;EACI,yBAAA;EACA,yBAAA;EACA,YAAA;AADJ;;AAIA;EACI,oCAAA;EACA,YAAA;EACA,uBAAA;AADJ;;AAIA;EACI,2BAAA;AADJ;;AAIA;;;EAGI,cAAA;AADJ;;AAIA;;;;EAII,kCAAA;AADJ;;AAIA;;;;;EAKI,sBAAA;AADJ;;AAIA;;EAEI,WAAA;AADJ;;AAIA;;EAEI,cAAA;AADJ;;AAIA;;EAEI,WAAA;AADJ;;AAIA;EACI,yBAAA;EACA,uBAAA;EACA,qBAAA;EACA,0BAAA;EACA,qDAAA;AADJ;;AAIA;EACI,uBAAA;AADJ;;AAIA;EACI,YAAA;EACA,UAAA;AADJ;;AAIA;EACI,YAAA;EACA,UAAA;AADJ","sourcesContent":["$admin-assets: #{\"/assets/administration/\"};\nh3 {\n    margin-top: 25px;\n    margin-bottom: 15px;\n}\n\ninput[type=text] {\n    border: 0;\n    padding: inherit;\n    width: 100%;\n}\n\n.accntInfo table tr td label {\n    font-size: 14px;\n    margin-bottom: auto;\n}\n\n.accntInfo table tr td:nth-child(2) {\n    padding-left: 5px;\n}\n\n.accntInfo table tr td {\n    padding-top: 12px;\n}\n\n#subAccountDisplay {\n    max-height: 75px;\n    ;\n}\n\ntr.actionModify {\n    margin-bottom: 8px;\n}\n\ntr.actionModify td {\n    border-bottom: 1px solid #EDF2F5;\n    padding-bottom: 2px;\n}\n\ntr.actionModify td:nth-child(2){\n    padding-right: 15px;\n}\n\ntr.actionModify td:last-child {\n    width: auto !important;\n    vertical-align: middle;\n}\n\n.hide {\n    display: none;\n}\n\nselect {\n    background-color: white;\n    width: 100%;\n    border: 0;\n    border-radius:0;\n    padding:0;\n}\nselect option {\n    padding-left: 0;\n}\n\n\ntr.actionModify td:first-child {\n    width: 150px;\n}\n\ntr.actionModify td:last-child div.editable {\n    display: none;\n}\n\ntr.actionModify:hover td:last-child div.editable {\n    display: block;\n    cursor: pointer;\n}\n\ntr.actionModify:hover td:last-child div.editable div.editableIcon {\n    height: 16px;\n    width: 16px;\n    background: url($admin-assets + 'pencil-tool.png') no-repeat;\n}\n\ntr.actionModify:hover td:last-child div.editable div.editableIcon:hover {\n    background: url($admin-assets + 'pencil-tool_on.png') no-repeat;\n}\n\ntr.modifyButtons td {\n    padding-top: 0 !important;\n}\n\ntr.modifyButtons td div.edit {\n    text-align: right;\n}\n\ntr.modifyButtons td div.edit div.saveText,\ntr.modifyButtons td div.edit div.cancelText {\n    cursor: pointer;\n}\n\ntr.modifyButtons td div.edit div.saveText {\n    color: #007566;\n}\n\ntr.actionModify td:last-child div.edit div.cancelText {\n    cursor: pointer;\n}\n\ntr.modifyButtons td.modifyEnabled:nth-child(2), tr.actionModify td.modifyEnabled {\n    border-bottom: 2px solid #007566;\n}\n\ntr.actionModify td.splitLineTile:after {\n    content: \"\"; /* This is necessary for the pseudo element to work. */\n    display: block; /* This will put the pseudo element on its own line. */\n    margin: 0 0 -3px; /* This will center the border. */\n    width: 15%; /* Change this to whatever width you want. */\n    padding-top: 0; /* This creates some space between the element and the border. */\n    border-bottom: 2px solid #007566;\n    /* This creates the border. Replace black with whatever color you want. */\n}\n\ntable:not(.permissionsTable) tr td:nth-child(1) {\n    font-family: 'MontserratRegular',  sans-serif;\n}\n\n.permissionsTable {\n    width: 100%;\n}\n\n.permissionsTable td:first-child {\n    width: 16% !important;\n}\n\n.permissionsTable td:nth-child(even),\n.permissionsTable td.iacTd {\n    width: 5% !important;\n}\n\n.permissionsTable td:nth-child(3) {\n    width: 18% !important;\n}\n\n.permissionsTable td:nth-child(5),\n.permissionsTable td:nth-child(7) {\n    width: 12% !important;\n}\n\ndiv.col-md-6, .pdl0 {\n    padding-left: 0;\n}\n\n#pageHead {\n    width: 100%;\n    background-color: #F4F4F4;\n    margin: 0;\n    height: 50px;\n}\n\n.modalButton {\n    background-color: white;\n    color: #111111;\n}\n\n.modalButton:hover {\n    background-color: #EDF2F5;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp {\n    border: 0;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .datePicker {\n    padding: 0;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selector:focus {\n    border: 1px solid #BABABA !important;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selector {\n    border: 1px solid #BABABA !important;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selectorarrow:before {\n    border: none !important;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selectorarrow:focus:before {\n    border: none !important;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .daycell:hover .prevmonth,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .daycell:hover .nextmonth {\n    color: #111111;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .currmonth .sunday,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .sundayDim {\n    color: #999 !important;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selectedday {\n    border: 1px solid #686868;\n    background-color: #BABABA;\n    color: black\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selectedday div {\n    background-color: #BABABA !important;\n    color: black;\n    border: none !important;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .headertodaybtn {\n    border-radius: 0 !important;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .caltable,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .daycell,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .weekdaytitle {\n    color: #111111;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .mydpicon:hover,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .mydpicon:focus,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .btnpicker:hover,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .btnpicker:focus {\n    background-color: white !important;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .btnclear:hover,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .btnclear:focus,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .mydpicon:hover,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .daycell:hover,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .headertodaybtn:hover {\n    background-color: #CCC;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .headerbtn:hover,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .headerlabelbtn:hover {\n    color: #CCC\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .icon-mydpleft:hover,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .icon-mydpright:hover {\n    color: #111111\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .icon-mydpleft:focus,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .icon-mydpright:focus {\n    color: #999\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selection {\n    font-size: 9pt !important;\n    height: auto !important;\n    padding: 0 !important;\n    margin-top: 3px !important;\n    font-family: 'MontserratLight',  sans-serif !important;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .selbtngroup {\n    height: auto !important;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .selbtngroup .btnclear {\n    height: auto;\n    padding: 0;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .selbtngroup .btnpicker {\n    height: auto;\n    padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
